import React from 'react';
import { FiChevronRight } from 'react-icons/fi';

import { Text, textVariantsEnum, fontWeightEnum } from '@components/Text';
import { IconBadge, iconBadgeSizes } from '@components/IconBadge';
import { StatusBadge, statusBadgeTones } from '@components/StatusBadge';

import styles from './QuickSettingCard.module.scss';

export const QuickSettingCard = ({
  icon,
  iconBg,
  title,
  description,
  status,
  onClick,
  control,
}) => (
  <div
    className={styles.card}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    onClick={onClick}
  >
    <IconBadge size={iconBadgeSizes.md} bg={iconBg} icon={icon} />
    <div className={styles.textStack}>
      <Text
        variant={textVariantsEnum.Text_sm}
        fontWeight={fontWeightEnum.Semibold}
        color="gray-900"
      >
        {title}
      </Text>
      <Text
        variant={textVariantsEnum.Text_xs}
        fontWeight={fontWeightEnum.Normal}
        color="gray-500"
      >
        {description}
      </Text>
      {status && (
        <StatusBadge
          label={status}
          tone={statusBadgeTones.success}
          className={styles.status}
        />
      )}
    </div>
    <div className={styles.control} onClick={(e) => e.stopPropagation()}>
      {control || <FiChevronRight size={16} color="var(--gray-400)" />}
    </div>
  </div>
);

QuickSettingCard.displayName = 'QuickSettingCard';
